import type { ReactNode } from 'react';
import { useMemo, useState, useContext, createContext } from 'react';

import type { SetState } from '@/types/helpers';

type AccordionContextType = {
  expandedId: string | null;
  setExpandedId: SetState<string | null>;
};

const AccordionContext = createContext<AccordionContextType | null>(null);

export const useAccordion = () => {
  const context = useContext(AccordionContext);
  if (!context) throw new Error('useAccordion must be used within an AccordionProvider');
  return context;
};

export const useOptionalAccordion = () => {
  return useContext(AccordionContext);
};

export const AccordionProvider = ({
  children,
  defaultExpandedId = null
}: {
  children: ReactNode;
  defaultExpandedId?: string | null;
}) => {
  const [expandedId, setExpandedId] = useState<string | null>(defaultExpandedId);
  const value = useMemo(() => ({ expandedId, setExpandedId }), [expandedId]);

  return <AccordionContext.Provider value={value}>{children}</AccordionContext.Provider>;
};
